var exports = {
  "g": "userSelectNone__I6NSfK",
};

module.exports = exports;
